@let alertMessage = alertMessage$ | async;
@if (alertMessage?.enabled) {
  <mat-toolbar
    color="warn"
    sticky
    style="display: flex; flex-direction: column; align-items: center; justify-content: center"
  >
    <span style="width: 100%; text-align: center">{{ alertMessage?.message }}</span>
    <span style="width: 100%; text-align: center; font-size: 0.875rem">{{ alertMessage?.secondLine }}</span>
  </mat-toolbar>
}
